import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Card from '../components/Card.jsx';
import Button from '../components/Button.jsx';
import '../styles/Invitations.css';
import classicEleganceCover from '../assets/images/template_cover/classic-elegance.png';
import modernRomanceCover from '../assets/images/template_cover/modern-romance.png';
import rusticGardenCover from '../assets/images/template_cover/rustic-garden.png';
import kidsPartyFunCover from '../assets/images/template_cover/kids-party-fun.png';
import elegantMilestoneCover from '../assets/images/template_cover/elegant-milestone.png';
import fiestaThemeCover from '../assets/images/template_cover/fiesta-theme.png';
import angelicWhiteCover from '../assets/images/template_cover/angelic-white.png';
import blessedJourneyCover from '../assets/images/template_cover/blessed-journey.png';
import professionalBlueCover from '../assets/images/template_cover/professional-blue.png';
import executiveGoldCover from '../assets/images/template_cover/executive-gold.png';
import silverAnniversaryCover from '../assets/images/template_cover/silver-wedding.png';
import goldenYearsCover from '../assets/images/template_cover/golden-years.png';
const Invitations = () => {
  const [searchParams] = useSearchParams();
  const categoryParam = searchParams.get('category');
  const [filter, setFilter] = useState(categoryParam || 'all');

  useEffect(() => {
    if (categoryParam) {
      setFilter(categoryParam);
    }
  }, [categoryParam]);

  const templates = [
    // Wedding Templates
    {
      id: 1,
      title: 'Classic Elegance',
      category: 'wedding',
      slug: 'classic-elegance',
      image: classicEleganceCover,
      description: 'Timeless and sophisticated wedding invitation with floral accents',
      price: '₱200'
    },
    {
      id: 2,
      title: 'Modern Romance',
      category: 'wedding',
      slug: 'modern-romance',
      image: modernRomanceCover,
      description: 'Contemporary design with minimalist elegance',
      price: '₱250'
    },
    {
      id: 3,
      title: 'Rustic Garden',
      category: 'wedding',
      slug: 'rustic-garden',
      image: rusticGardenCover,
      description: 'Nature-inspired design with botanical elements',
      price: '₱300'
    },
    // Birthday Templates
    {
      id: 4,
      title: 'Kids Party Fun',
      category: 'birthday',
      slug: 'kids-party-fun',
      image: kidsPartyFunCover,
      description: 'Colorful and playful design for children\'s parties',
      price: '₱200'
    },
    {
      id: 5,
      title: 'Elegant Milestone',
      category: 'birthday',
      slug: 'elegant-milestone',
      image: elegantMilestoneCover,
      description: 'Sophisticated design for milestone celebrations (18th, 50th, etc.)',
      price: '₱250'
    },
    {
      id: 6,
      title: 'Fiesta Theme',
      category: 'birthday',
      slug: 'fiesta-theme',
      image: fiestaThemeCover,
      description: 'Vibrant Filipino fiesta-inspired celebration',
      price: '₱200'
    },
    // Christening Templates
    {
      id: 7,
      title: 'Angelic White',
      category: 'christening',
      slug: 'angelic-white',
      image: angelicWhiteCover,
      description: 'Pure and heavenly design for baptism celebrations',
      price: '₱200'
    },
    {
      id: 8,
      title: 'Blessed Journey',
      category: 'christening',
      slug: 'blessed-journey',
      image: blessedJourneyCover,
      description: 'Beautiful religious-themed invitation',
      price: '₱250'
    },
    // Corporate Templates
    {
      id: 9,
      title: 'Professional Blue',
      category: 'corporate',
      slug: 'professional-blue',
      image: professionalBlueCover,
      description: 'Clean and professional design for business events',
      price: '₱200'
    },
    {
      id: 10,
      title: 'Executive Gold',
      category: 'corporate',
      slug: 'executive-gold',
      image: executiveGoldCover,
      description: 'Premium design for high-profile corporate events',
      price: '₱300'
    },
    // Anniversary Templates
    {
      id: 11,
      title: 'Silver Anniversary',
      category: 'anniversary',
      slug: 'silver-anniversary',
      image: silverAnniversaryCover,
      description: 'Elegant silver-themed 25th anniversary design',
      price: '₱250'
    },
    {
      id: 12,
      title: 'Golden Years',
      category: 'anniversary',
      slug: 'golden-years',
      image: goldenYearsCover,
      description: 'Luxurious gold-themed celebration invitation',
      price: '₱300'
    }
  ];

  const categories = [
    { value: 'all', label: 'All Templates' },
    { value: 'wedding', label: 'Wedding' },
    { value: 'birthday', label: 'Birthday' },
    { value: 'christening', label: 'Christening' },
    { value: 'corporate', label: 'Corporate' },
    { value: 'anniversary', label: 'Anniversary' }
  ];

  const filteredTemplates = filter === 'all' 
    ? templates 
    : templates.filter(t => t.category === filter);

  return (
    <div className="invitations">
      <div className="invitations-header">
        <h1>E-Invitation Templates</h1>
        <p>Browse our collection of beautifully designed digital invitations</p>
        <div className="pricing-badges">
          <p className="price-note">Templates: <strong>₱200 - ₱300</strong></p>
          <p className="price-note custom">Custom Design: <strong>₱350 - ₱700</strong></p>
        </div>
      </div>

      <div className="filter-section">
        <div className="filter-buttons">
          {categories.map((cat) => (
            <button
              key={cat.value}
              className={`filter-btn ${filter === cat.value ? 'active' : ''}`}
              onClick={() => setFilter(cat.value)}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      <div className="templates-grid">
        {filteredTemplates.map((template) => (
          <div key={template.id} className="template-card-wrapper">
            {template.slug && (
              <a href={`/${template.category}/templates/${template.slug}`} target="_blank" rel="noopener noreferrer" className="preview-overlay">
                <span className="preview-text">Click to Preview</span>
              </a>
            )}
            <Card
              title={template.title}
              description={template.description}
              image={template.image}
              className="template-card"
              category={template.category}
              categoryLabel={categories.find(c => c.value === template.category)?.label || template.category}
            />
          </div>
        ))}
      </div>

      <div className="templates-cta">
        <h3>Don't see what you're looking for?</h3>
        <p>We can create custom designs based on your preferences and theme!</p>
        <p className="custom-price-note">Custom design price: <strong>₱350 - ₱700</strong></p>
        <Link to="/book?type=custom">
          <Button variant="primary" size="large">
            Request Custom Design
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Invitations;
